import React, { useState } from "react";
import { Select } from "antd";
import { useTranslation } from "../../../i18n/LanguageContext";

const { Option } = Select;

const Filters = ({ onChange, ticketTypes, statuses, pagination, setFilters, setPagination }) => {
   const { t } = useTranslation();
   const [typeId, setTypeId] = useState(null);
   const [statusId, setStatusId] = useState(null);

   const handleFilterChange = (key, value) => {
      setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
      setPagination({ ...pagination, pageNumber: 1 });
      onChange(key, value);
   };
   const handleTypeChange = (value) => {
      setTypeId(value);
      handleFilterChange("TypeId", value);
   };

   const handleStatusChange = (value) => {
      setStatusId(value);
      onChange("StatusId", value);
   };

   return (
      <div style={{ display: "flex", gap: "24px" }}>
         <Select
            placeholder={t("filter-tickets-by-type-placeholder")}
            allowClear
            // showSearch
            style={{ width: 200 }}
            value={typeId}
            onChange={handleTypeChange}
         >
            {ticketTypes.map((type) => (
               <Option key={type.value} value={type.value}>
                  {type.label}
               </Option>
            ))}
         </Select>
         <Select
            placeholder={t("filter-tickets-by-status-placeholder")}
            allowClear
            // showSearch
            style={{ width: 200 }}
            value={statusId}
            onChange={handleStatusChange}
         >
            {statuses.map((status) => (
               <Option key={status.value} value={status.value}>
                  {status.label}
               </Option>
            ))}
         </Select>
      </div>
   );
};

export default Filters;
